import React, { useEffect, useState } from "react";
import { Mail, Download } from "lucide-react";
import api from "../../lib/api";

export default function AdminNewsletter() {
  const [subs, setSubs] = useState([]);

  useEffect(() => {
    api.get("/admin/newsletter").then(({ data }) => setSubs(data)).catch(() => {});
  }, []);

  const exportCsv = () => {
    const rows = ["email,ημερομηνία", ...subs.map((s) => `${s.email},${s.created_at}`)];
    const blob = new Blob([rows.join("\n")], { type: "text/csv" });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url; a.download = "newsletter.csv"; a.click();
    URL.revokeObjectURL(url);
  };

  return (
    <div>
      <div className="flex items-center justify-between mb-1">
        <h1 className="font-serif-display text-3xl text-[#1E3A2F]">Newsletter</h1>
        {subs.length > 0 && (
          <button onClick={exportCsv} data-testid="export-newsletter" className="inline-flex items-center gap-2 border border-[#1E3A2F] text-[#1E3A2F] px-4 py-2.5 rounded-sm text-sm font-medium hover:bg-[#1E3A2F] hover:text-white">
            <Download className="h-4 w-4" /> Εξαγωγή CSV
          </button>
        )}
      </div>
      <p className="text-[#536D61] mb-6 text-sm">Εγγεγραμμένοι ({subs.length})</p>

      {subs.length ? (
        <div className="bg-white border border-[#E5E9E4] rounded-sm overflow-x-auto">
          <table className="w-full text-sm">
            <thead>
              <tr className="text-left text-[#536D61] border-b border-[#E5E9E4]">
                <th className="py-3 px-4 font-medium">Email</th>
                <th className="py-3 px-4 font-medium">Ημερομηνία εγγραφής</th>
              </tr>
            </thead>
            <tbody>
              {subs.map((s) => (
                <tr key={s.id} className="border-b border-[#F0F2EE] hover:bg-[#F9F8F6]">
                  <td className="py-3 px-4 text-[#1E3A2F]"><a href={`mailto:${s.email}`} className="hover:underline">{s.email}</a></td>
                  <td className="py-3 px-4 text-[#536D61]">{s.created_at ? new Date(s.created_at).toLocaleDateString("el-GR") : "—"}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      ) : (
        <div className="bg-white border border-dashed border-[#E5E9E4] rounded-sm py-16 text-center text-[#536D61]">
          <Mail className="h-10 w-10 text-[#1E3A2F]/30 mx-auto mb-3" />
          Καμία εγγραφή ακόμη.
        </div>
      )}
    </div>
  );
}
